export default "__VITE_ASSET__Bb3nqvv2__"